export enum ElementsPackTypes {
  TextBlocks = 'textBlocks',
  Signatures = 'signatures',
  QRCode = 'qrCode',
  Lists = 'lists',
  ImageFrames = 'imageFrames',
  ImageGrids = 'imageGrids',
  VideoEmbed = 'videoEmbed',
  Gifs = 'gifs',
  InteractiveList = 'interactiveList',
}
